// extracted by mini-css-extract-plugin
export default {"Table":"dhjno"};